import { gql, useLazyQuery } from '@apollo/client'
import { AutocompleteOption } from '@farol-ds/react'
import { useCallback, useMemo } from 'react'

export type SearchEmecLawInstitutionsQueryVariables = {
  query: string
  limit?: number | null
}

export type SearchEmecLawInstitutionsQuery = {
  readonly root?: {
    readonly searchEmecLawInstitutions: ReadonlyArray<{
      readonly nome: string
      readonly sigla: string | null
    }>
  } | null
}

export const SEARCH_EMEC_LAW_INSTITUTIONS_QUERY = gql`
  query SearchEmecLawInstitutions($query: String!, $limit: Int) {
    root {
      searchEmecLawInstitutions(query: $query, limit: $limit) {
        nome
        sigla
      }
    }
  }
`

export interface EmecLawInstitutionOption {
  nome: string
  sigla: string | null
}

export const useSearchEmecLawInstitutions = () => {
  const [search, { data, loading }] = useLazyQuery<
    SearchEmecLawInstitutionsQuery,
    SearchEmecLawInstitutionsQueryVariables
  >(SEARCH_EMEC_LAW_INSTITUTIONS_QUERY, {
    fetchPolicy: 'network-only',
  })

  const searchInstitutions = useCallback(
    (query: string, limit = 20) => {
      const trimmed = query.trim()
      if (trimmed.length < 2) {
        return
      }

      search({ variables: { query: trimmed, limit } })
    },
    [search]
  )

  const institutions = useMemo(
    () => data?.root?.searchEmecLawInstitutions ?? [],
    [data?.root?.searchEmecLawInstitutions]
  )

  const autocompleteOptions: AutocompleteOption[] = useMemo(
    () =>
      institutions.map((entry, index) => ({
        id: index,
        label: entry.sigla ? `${entry.sigla} — ${entry.nome}` : entry.nome,
        value: entry.nome,
      })),
    [institutions]
  )

  return {
    searchInstitutions,
    autocompleteOptions,
    institutions,
    loading,
  }
}
